<template>
  <div class="grey lighten-4 pa-4" style="min-height: 100vh;">
    <v-container>
      <v-card>
        <v-toolbar flat color="deep-purple darken-1" dark>
          <v-toolbar-title>
            <v-icon left>mdi-calendar-star</v-icon>
            Administración de Eventos
          </v-toolbar-title>
        </v-toolbar>

        <!-- PC: Tabs con flechas -->
        <v-tabs v-if="$vuetify.breakpoint.mdAndUp" v-model="tab" show-arrows
          background-color="deep-purple lighten-5">
          <v-tab v-for="item in sections" :key="item.key" :href="'#' + item.key">
            <v-icon left small>{{ item.icon }}</v-icon>
            {{ item.text }}
          </v-tab>
        </v-tabs>

        <!-- Mobile: Select -->
        <div v-else class="pa-3">
          <v-select v-model="tab" :items="sections" item-text="text" item-value="key"
            outlined dense hide-details prepend-inner-icon="mdi-menu">
          </v-select>
        </div>

        <v-tabs-items v-model="tab">
          <!-- TAB CATEGORÍAS -->
          <v-tab-item value="categorias">
            <event-category-admin></event-category-admin>
          </v-tab-item>

          <!-- TAB ORGANIZADORES -->
          <v-tab-item value="organizadores">
            <event-organizer-admin></event-organizer-admin>
          </v-tab-item>

          <!-- TAB EVENTOS -->
          <v-tab-item value="eventos">
            <event-admin ref="eventAdmin"></event-admin>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import EventCategoryAdmin from '@/components/event/EventCategoryAdmin.vue';
import EventOrganizerAdmin from '@/components/event/EventOrganizerAdmin.vue';
import EventAdmin from '@/components/event/EventAdmin.vue';

export default {
  name: 'EventAdminV',
  components: {
    EventCategoryAdmin,
    EventOrganizerAdmin,
    EventAdmin
  },
  data() {
    return {
      tab: 'categorias',
      sections: [
        { key: 'categorias', text: 'Categorías', icon: 'mdi-tag-multiple' },
        { key: 'organizadores', text: 'Organizadores', icon: 'mdi-account-group' },
        { key: 'eventos', text: 'Eventos', icon: 'mdi-calendar-star' },
      ]
    };
  },
  watch: {
    tab(newVal) {
      if (newVal === 'eventos' && this.$refs.eventAdmin) {
        this.$refs.eventAdmin.cargarCategorias();
        this.$refs.eventAdmin.cargarOrganizadores();
      }
    }
  }
};
</script>
